import axios from "axios";

const KPI_API_BASE = "https://usibras-web-backend.onrender.com/api";

/**
 * Login to the KPI Performance Management system.
 *
 * @param {Object} credentials
 * @param {string} credentials.email - Work email
 * @param {string} credentials.password - Password
 * @returns {Promise<{ token: string, token_type: string, expires_in: number, user: Object, message: string }>}
 */
export async function loginKpiUser(credentials) {
  const response = await axios.post(`${KPI_API_BASE}/kpi-users/login`, {
    email: credentials.email?.trim() || "",
    password: credentials.password || "",
  });
  return response.data;
}
